import React, { useState, useEffect } from "react";
import SideBar from "../SideBar/SideBar";
import "./Dashboard.css";
import Loader from "../../Components/Loader/Loader";
import VouchurePic from "../../assets/vouchure.svg";
import { Col, Row, Image } from "react-bootstrap";
import { DashboardAPI } from "./../API/Dashboard/Dashboard";
import CouponsSummary from "./../SideBar_4/CouponsSummary";
import DashboardCategories from "./DashboardCategories";
import VoucherSummary from "../SideBar_3/VoucherSummary";
import { AllCategoriesAPI } from "./../API/Dashboard/AllCategories";
import DashboardAllCategories from "./DashboardAllCategories";
import CouponsImg from "../../assets/coupens.svg";
import HomeGreen from "../../assets/dd-1.svg";
import HomeMap from "../../assets/dd-2.svg";
import HomePlus from "../../assets/dd-3.svg";
import RiseArrow from "../../assets/dd-4.svg";
import webPage from "../../assets/dd-5.svg";
import webArrow from "../../assets/dd-6.svg";
import PrivacyTermsConditions from "../PrivacyTermsConditions/PrivacyTermsConditions";
import swal from "sweetalert";
import NoDataText from "../NoDataText";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const [loading, setLoading] = useState(false);
  const [cardData, setcardData] = useState([]);
  const [CouponData, setCouponData] = useState([]);
  const [VoucherData, setVoucherData] = useState([]);
  const [TableData, setTableData] = useState([]);
  const [AllTableData, setAllTableData] = useState([]);
  const [currentTab, setcurrentTab] = useState("");
  const [pageCount, setPageCount] = useState("");
  const [pageNumber, setPageNumber] = useState(0);

  const path = window.location.href;
  const endPath = path.split("/");

  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    // console.log(endPath[3],"endPath[3]")
    if (endPath[3] === "dashboard") {
      setcurrentTab("top-categories");
      ApiLoad();
    }
    if (endPath[4] === "all-categories") {
      setcurrentTab("all-categories");
      ApiAllCategories();
    }
  }, [path, pageNumber]);

  const ApiLoad = async () => {
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
    };
    const coupondetailData = await DashboardAPI(data, () => {
      navigate("/");
    });
    setLoading(false);
    if (coupondetailData == false) {
      swal({
        // title: "Error!",
        title: NoDataText.InternalErr,
        icon: "error",
        buttons: "Ok",
        dangerMode: true,
      });
    } else {
      if (coupondetailData.success == true) {
        setcardData(coupondetailData.header);
        setCouponData(coupondetailData.coupon_summary);
        setVoucherData(coupondetailData.voucher_summary);
        setTableData(coupondetailData?.top_categories);
      } else if (coupondetailData.status === 429) {
        swal({
          // title: "Error!",
          title: coupondetailData.message,
          icon: "error",
          buttons: "Ok",
          dangerMode: true,
        });
        setLoading(true);
      } else {
        swal({
          // title: "Error!",
          title: coupondetailData.message,
          icon: "error",
          buttons: "Ok",
          dangerMode: true,
        });
      }
    }
  };

  const ApiAllCategories = async () => {
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
      column_name: "new",
      limit: 10,
      offset: pageNumber,
      sort_type: 1,
    };

    const coupondetailData = await AllCategoriesAPI(data, () => {
      navigate("/");
    });
    setLoading(false);

    if (coupondetailData == false) {
      swal({
        // title: "Error!",
        title: NoDataText.InternalErr,
        icon: "error",
        buttons: "Ok",
        dangerMode: true,
      });
    } else {
      if (coupondetailData.success == true) {
        setAllTableData(coupondetailData?.all_categories);
        setPageCount(coupondetailData?.total_row);
      }else if(coupondetailData.status == 429){
        swal({
          // title: "Error!",
          title: coupondetailData.message,
          icon: "error",
          buttons: "Ok",
          dangerMode: true,
        });
        setLoading(true)
      } else {
        swal({
          // title: "Error!",
          title: coupondetailData.message,
          icon: "error",
          buttons: "Ok",
          dangerMode: true,
        });
        setAllTableData([]);
        setPageCount(0);
      }
    }
  };

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <SideBar />
        </div>
        <div className="main-content pt-5 pr-3 pb-4 dashboardmms">
          <p className="page-maintitle">Dashboard</p>
          <Row className="dashboard-card mt-4 ">
            <Col md="3">
              <div className="card green-card">
                <div className="dash-img-main">
                  <div className="dash-img">
                    <Image src={HomeGreen} height="30px"></Image>
                  </div>
                </div>
                <div className="dash-content">
                  <p className="dash-text1 pt-4">
                    Total Business
                    <br /> Registered
                  </p>
                  <p className="dash-text2">
                    {cardData.total_published_registered == null
                      ? "0"
                      : cardData.total_published_registered}
                  </p>
                  <p className="text-right pb-3"></p>
                </div>
              </div>
            </Col>
            <Col md="3">
              <div className="card green-card">
                <div className="dash-img-main">
                  <div className="dash-img">
                    <Image src={HomeMap} height="30px"></Image>
                  </div>
                </div>
                <div className="dash-content">
                  <p className="dash-text1 pt-4">
                    Total Business
                    <br /> Published
                  </p>
                  <p className="dash-text2">
                    {cardData.total_business_registered == null
                      ? "0"
                      : cardData.total_business_registered}
                  </p>
                  <p className="text-right pb-3"></p>
                </div>
              </div>
            </Col>
            <Col md="3">
              <div className="card green-card">
                <div className="dash-img-main">
                  <div className="dash-img">
                    <Image src={HomePlus} height="30px"></Image>
                  </div>
                </div>
                <div className="dash-content">
                  <p className="dash-text1 pt-4">
                    New Business
                    <br /> Registration
                  </p>
                  <p className="dash-text2">
                    {cardData.new_business_registered == null
                      ? "0"
                      : cardData.new_business_registered}
                  </p>
                  <p className="text-right pb-3"></p>
                </div>
              </div>
            </Col>
            <Col md="3">
              <div className="card green-card">
                <div className="dash-img-main">
                  <div className="dash-img">
                    <Image src={RiseArrow} height="30px"></Image>
                  </div>
                </div>
                <div className="dash-content">
                  <p className="dash-text1 pt-4">
                    Economic
                    <br />
                    Impact
                  </p>
                  <p className="dash-text2">
                    <span className="dash-text2">$</span>
                    {cardData.econonic_impact == null
                      ? "0"
                      : cardData.econonic_impact}
                  </p>
                  <p className="text-right pb-3"></p>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="dashboard-card mt-4 ">
            <Col md="3">
              <div className="card py-3">
                <div className="dash-img-main">
                  <div className="dash-img">
                    <img src={VouchurePic} height="30px" />
                  </div>
                </div>
                <div className="dash-content">
                  <p className="dash-text1 pt-4">Total Active Vouchers</p>
                  <p className="dash-text2">
                    {cardData.total_voucher == null
                      ? "0"
                      : cardData.total_voucher}
                  </p>
                  <p className="text-right pb-3"></p>
                </div>
              </div>
            </Col>
            <Col md="3">
              <div className="card py-3">
                <div className="dash-img-main">
                  <div className="dash-img">
                    <Image src={CouponsImg} height="30px"></Image>
                  </div>
                </div>
                <div className="dash-content">
                  <p className="dash-text1 pt-4">Total Active Coupons</p>
                  <p className="dash-text2">
                    {cardData.total_coupon == null
                      ? "0"
                      : cardData.total_coupon}
                  </p>
                  <p className="text-right pb-3"></p>
                </div>
              </div>
            </Col>
            <Col md="3">
              <div className="card py-3">
                <div className="dash-img-main">
                  <div className="dash-img">
                    <Image src={webPage} height="30px"></Image>
                  </div>
                </div>
                <div className="dash-content">
                  <p className="dash-text1 pt-4">Total Traffic</p>
                  <p className="dash-text2">
                    {cardData.total_traffic == null
                      ? "0"
                      : cardData.total_traffic}
                    <span className="dash-text2"></span>
                  </p>
                  <p className="text-right pb-3"></p>
                </div>
              </div>
            </Col>
            <Col md="3">
              <div className="card py-3">
                <div className="dash-img-main">
                  <div className="dash-img">
                    <Image src={webArrow} height="30px"></Image>
                  </div>
                </div>
                <div className="dash-content">
                  <p className="dash-text1 pt-4">Total Clicks</p>
                  <p className="dash-text2">
                    {cardData.total_clicks == null
                      ? "0"
                      : cardData.total_clicks}
                    <span className="dash-text2"></span>
                  </p>
                  <p className="text-right pb-3"></p>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <VoucherSummary summaryData={VoucherData} />
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <CouponsSummary summaryData={CouponData} />
            </Col>
          </Row>
          <div className="mt-4 topAndAllCat">
            {currentTab == "top-categories" && (
              <DashboardCategories TableData={TableData} />
            )}
            {currentTab == "all-categories" && (
              <DashboardAllCategories
                PageCount={pageCount}
                AllTableData={AllTableData}
                setAllTableData={setAllTableData}
                setLoading={setLoading}
                SetPageNumber={setPageNumber}
              />
            )}
          </div>
        </div>
        <PrivacyTermsConditions />
      </div>
    </>
  );
};

export default Dashboard;
